import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ENTITIES } from '../../../constants';
import { useEntityList } from '../../../hooks/useEntityList';
import { filterItems } from '../../../utils/filterUtils';
import DateSelector from '../../DateSelector';
import EntityTable from '../EntityTable';
import SearchBar from '../SearchBar';

const BookingsTab = ({
  selectedDate,
  setSelectedDate,
  userEmail,
  getOptionLabel,
  memberTypeNames
}) => {
  const { t } = useTranslation();
  const entity = ENTITIES.bookings;
  const [searchQuery, setSearchQuery] = useState('');

  const { items, isLoading, error, reload } = useEntityList(
    entity,
    selectedDate,
    userEmail
  );

  const filteredItems = useMemo(() => {
    return filterItems(items, searchQuery, entity?.columns, getOptionLabel, memberTypeNames);
  }, [items, searchQuery, entity?.columns, getOptionLabel, memberTypeNames]);

  const noResultsText = (!t('no-search-results') || t('no-search-results') === 'no-search-results')
    ? 'Inga resultat matchade sökningen.'
    : t('no-search-results');

  return (
    <>


      {error && (
        <div className="banner-card error-banner card wrapper-width flex flex-align-center-v" style={{ background: '#ffebee', color: '#c62828', padding: '10px 20px', margin: '10px auto', borderRadius: '4px', justifyContent: 'space-between' }}>
          <span>{error}</span>
          <button className="button" style={{ padding: '4px 10px' }} onClick={reload}>Retry</button>
        </div>
      )}

      <div className="flex center wrapper-width-small">

        <div className="card card-large padding-card-small width-max-content position-relative">

          <div style={{paddingBottom:'11px'}} className="flex flex-align-center-v position-relative list-bookings-bar">

            <div className="position-absolute" style={{width: '380px',left: 0, transform: 'translateY(-50%)',top: '44%',zIndex: '1'}}>
              <SearchBar
                  value={searchQuery}
                  onChange={setSearchQuery}
                  placeholder={t('search')}
              />
            </div>

            <DateSelector
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                type="desktop"
            />

          </div>

          <ul id="items-list" className={`${entity.listAction}`}>

            {isLoading ? (
              <div className="spinner"></div>
            ) : (
              <EntityTable
                items={filteredItems}
                columns={entity.columns}
                schema={entity.schema}
                listType={entity.listAction}
                getOptionLabel={getOptionLabel}
                canEdit={false}
                canDelete={false}
                allMemberTypeNames={memberTypeNames}
                emptyMessage={searchQuery ? noResultsText : undefined}
              />
            )}
          </ul>

        </div>

      </div>
    </>
  );
};

export default BookingsTab;
export { BookingsTab };
